<script setup lang="ts">
import {computed} from "vue";
import dayjs from "dayjs";
import dateHelper from "@/core/helpers/dateHelper";
import formatHelper from "@/core/helpers/formatHelper";

const {bgColorClass = 'bg-gray-100 hover:bg-lightPurple-lightest', at} = defineProps<{
    bgColorClass?: string,
    at: string,
}>();

const dateLabel = computed(() => {
    if (!dayjs(at).isValid()) {
        return at;
    }

    if (dayjs(at).isSame(dayjs(), 'day')) {
        return dateHelper.relativeFormat(at);
    }

    return formatHelper.readableDate(at);
});
</script>

<template>
  <div class="flex flex-col">
    <div
      class="relative flex items-center w-80 rounded-lg "
      :class="bgColorClass"
    >
      <div class="relative -left-4 w-16 h-16 flex items-center justify-center">
        <slot name="image" />
      </div>
      <div class="text-sm py-2">
        <slot />
      </div>
    </div>
    <div class="self-end">
      <p class="text-sm pt-1">
        {{ dateLabel }}
      </p>
    </div>
  </div>
</template>
